// Centralised copy-final action with toast feedback. Call sites just
// fire `copyFinalWithToast()`; success / blocked / no-guess / failure
// each map to a distinct toast so the user knows why nothing changed
// when the clipboard wasn't written.

import { copyFinal, isCommandError } from "../ipc/commands";
import { useStore } from "../state/store";

export async function copyFinalWithToast(): Promise<void> {
  const showToast = useStore.getState().showToast;
  try {
    const outcome = await copyFinal();
    switch (outcome.kind) {
      case "copied":
        showToast("Copied final guess", "ok");
        return;
      case "no_guess":
        showToast("No final guess yet — capture a round", "warn");
        return;
      case "blocked_foreground_geoguessr":
        showToast(
          "Skipped: GeoGuessr is focused — alt-tab to Atlas before copying",
          "warn",
        );
        return;
      case "blocked_ambiguous_browser":
        showToast(
          "Skipped: a browser is focused with no readable title — alt-tab to Atlas before copying",
          "warn",
        );
        return;
    }
  } catch (e) {
    const message = isCommandError(e) ? e.user_message : String(e);
    showToast(`Copy failed: ${message}`, "error");
  }
}
